import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetUserMagazineService {

  constructor(private http: HttpClient) {}

  async getAllSubMagazine(id) {
    try { 
      let response = await this.http
        .get(`${appApiResources.getUserMagazine}?partner_id=${id}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}